import React, { useState, useEffect } from 'react';
import { Users } from 'lucide-react';
import echo from '../services/echo';
import { API_CONFIG } from '../config/apiConfig';

const EventParticipants = ({ eventId }) => {
    const [participants, setParticipants] = useState([]);
    const [loading, setLoading] = useState(true);

    const getAdminToken = () => {
        return localStorage.getItem('cinestream_token')
    };

    useEffect(() => {
        if (!eventId) return;

        // Charger participants initiaux
        fetchInitialParticipants();

        // 📡 S'abonner aux mises à jour WebSocket
        const channel = echo.channel(`watch-party.${eventId}`);

        channel.listen('.participants.updated', (data) => {
            //console.log('Participants mis à jour:', data);
            setParticipants(data.participants || []);
        });

        // Cleanup
        return () => {
            echo.leave(`watch-party.${eventId}`);
        };
    }, [eventId]);

    const fetchInitialParticipants = async () => {
        try {
            const token = getAdminToken();
            if (!token) return;
            // ✅ Nouveau endpoint Laravel
            const response = await fetch(`${API_CONFIG.NEW_API_BASE}/watch-party/${eventId}/participants`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-Admin-Token': token
                }
            });
            const data = await response.json();
            if (data.success) {
                setParticipants(data.participants || []);
            }
        } catch (error) {
            console.error('Erreur chargement participants:', error);
        }
        setLoading(false);
    };

    if (loading || participants.length === 0) {
        return null;
    }

    return (
        <div className="flex items-center gap-2 mt-2 pt-2 border-t border-white/10">
            <Users className="w-4 h-4 text-purple-400 flex-shrink-0" />

            {/* Avatars */}
            <div className="flex -space-x-2">
                {participants.slice(0, 4).map((p, index) => (
                    <div
                        key={index}
                        className="w-6 h-6 rounded-full border-2 border-black flex items-center justify-center text-white text-xs font-bold"
                        style={{ backgroundColor: p.color || '#E8B75A' }}
                        title={p.username}
                    >
                        {p.username.slice(0, 1).toUpperCase()}
                    </div>
                ))}
                {participants.length > 4 && (
                    <div className="w-6 h-6 rounded-full bg-gray-700 border-2 border-black flex items-center justify-center text-white text-xs font-bold">
                        +{participants.length - 4}
                    </div>
                )}
            </div>

            {/* Compteur */}
            <span className="text-xs text-gray-400">
                {participants.length} {participants.length > 1 ? 'spectateurs' : 'spectateur'}
            </span>
        </div>
    );
};

export default EventParticipants;